// extracted by mini-css-extract-plugin
export default {"homePage":"home-page_homePage__jHwzb"};